import { Haptics, ImpactStyle } from "@capacitor/haptics";
import { Center, Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "../icons/icons";
import { useUserWrapperContext } from "../wrappers/UserWrapper";

const UserTitleBackHeader = ({ title }: { title: string }) => {
  const { topCollapsed } = useUserWrapperContext();

  const transition = "0.2s ease-out";
  const navigate = useNavigate();

  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  };

  return (
    <Flex
      h={topCollapsed ? "0" : "32px"}
      mb={topCollapsed ? "0" : "10px"}
      justifyContent="space-between"
      bg="white"
      transition={transition}
      overflow="hidden"
      position="relative"
    >
      <Center
        w="100%"
        h="100%"
        position="absolute"
        left="0"
        top="0"
        overflow="hidden"
      >
        <Text variant="title" fontSize="lg">
          {title}
        </Text>
      </Center>
      <IconButton
        minW="32px"
        h="32px"
        variant="light"
        aria-label="back"
        onClick={() => {
          triggerHapticFeedback(ImpactStyle.Medium);
          navigate(-1);
        }}
        icon={
          <Icon width="20px" height="19px" viewBox="0 0 23 20">
            <ArrowLeft color="#171C22" />
          </Icon>
        }
      />
    </Flex>
  );
};

export default UserTitleBackHeader;
